import { render } from "./CheckboxButtonGroup.vue?vue&type=template&id=01d4ce3b"
import script from "./CheckboxButtonGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__